import type { ReactNode } from 'react';

import { useLanguage } from '../lib/i18n/LanguageContext';
import { Modal } from './Modal';

/**
 * A styled stand-in for `window.confirm`, used wherever an action cannot be
 * undone from the portal — currently just revoking a key. Wrap the call site
 * in `<AnimatePresence>` (see Modal.tsx) for the open/close transition.
 */
export function ConfirmDialog({
  title,
  body,
  confirmLabel,
  danger = false,
  busy = false,
  error,
  onConfirm,
  onCancel,
}: {
  title: string;
  body: ReactNode;
  confirmLabel: string;
  danger?: boolean;
  busy?: boolean;
  error?: string | null;
  onConfirm: () => void;
  onCancel: () => void;
}) {
  const { dict } = useLanguage();
  return (
    <Modal title={title} onClose={onCancel}>
      <div className="modal-body">{body}</div>
      {error && <div className="err">{error}</div>}
      <div className="modal-actions">
        <button type="button" className="ghost" onClick={onCancel} disabled={busy}>
          {dict.common.cancel}
        </button>
        <button type="button" className={danger ? 'danger' : ''} onClick={onConfirm} disabled={busy}>
          {busy ? dict.common.working : confirmLabel}
        </button>
      </div>
    </Modal>
  );
}
